/**
 * A panel's filter (the Console's Category, the Content Browser's Type): a
 * label and the Inspector's select field, so every choice in the editor looks
 * the same. It's the browser's own select, whose list is drawn above every
 * panel, so it can't open underneath one.
 */
import "../widgets/widgets.css";
import "./filterSelect.css";

export interface FilterOption {
  readonly value: string;
  readonly label: string;
}

export interface FilterSelectProps {
  /** Shown before the field, and its accessible name. */
  readonly label: string;
  readonly value: string;
  readonly options: readonly FilterOption[];
  readonly onChange: (value: string) => void;
}

export function FilterSelect({ label, value, options, onChange }: FilterSelectProps) {
  return (
    <label className="kn-filter">
      <span className="kn-filter__label">{label}</span>
      <select
        className="kn-input kn-select kn-filter__select"
        value={value}
        onChange={(event) => {
          onChange(event.target.value);
        }}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}
